import {
  differenceInWeeks,
  differenceInCalendarDays,
  differenceInBusinessDays,
  addDays,
  addBusinessDays,
  addWeeks,
} from 'date-fns';

import { type LeadTimeUnit } from 'constants/all';

export const getLeadTimeFromShipsOnDate = ({
  fromDate,
  shipsOnDate,
  leadTimeDisplayUnit,
}: {
  fromDate: Date;
  shipsOnDate: Date;
  leadTimeDisplayUnit: LeadTimeUnit;
}) => {
  switch (leadTimeDisplayUnit) {
    case 'calendar_days':
      return differenceInCalendarDays(shipsOnDate, fromDate);
    case 'business_days':
      return differenceInBusinessDays(shipsOnDate, fromDate);
    case 'weeks':
      return differenceInWeeks(shipsOnDate, fromDate);
    default:
      throw new Error(`Invalid lead time display unit: ${leadTimeDisplayUnit}`);
  }
};

export const getShipsOnDateFromLeadTime = ({
  fromDate,
  leadTime,
  leadTimeDisplayUnit,
}: {
  fromDate: Date;
  leadTime: number;
  leadTimeDisplayUnit: LeadTimeUnit;
}) => {
  switch (leadTimeDisplayUnit) {
    case 'calendar_days':
      return addDays(fromDate, leadTime);
    case 'business_days':
      return addBusinessDays(fromDate, leadTime);
    case 'weeks':
      return addWeeks(fromDate, leadTime);
  }
};
